import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * `cn` — class-name composition utility used by every primitive.
 *
 * `clsx` handles the falsy-friendly conditional join; `twMerge`
 * resolves Tailwind utility collisions so a later override wins
 * (e.g. `cn("px-4", "px-6")` → `"px-6"`). This is the same pattern
 * shadcn/ui uses; we keep it identical so future copy-paste of
 * shadcn primitives plugs in without renaming.
 */
export function cn(...inputs: ReadonlyArray<ClassValue>): string {
  return twMerge(clsx(inputs));
}
